import { render, staticRenderFns } from "./ChangeBeneficiary.vue?vue&type=template&id=30e902da"
import script from "./ChangeBeneficiary.vue?vue&type=script&lang=js"
export * from "./ChangeBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports